export enum PartnerMarketingQueryKey {
    GetPartnerMarketingModel = "agoda:property-onboarding.getPartnerMarketingModel",
}
